import { render, staticRenderFns } from "./example-page.vue?vue&type=template&id=6de6f099"
import script from "./example-page.vue?vue&type=script&lang=js"
export * from "./example-page.vue?vue&type=script&lang=js"
import style0 from "./example-page.vue?vue&type=style&index=0&id=6de6f099&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports